export default "__VITE_ASSET__C5dlK$oQ__"